<span class="disclaimer-text align-{{ alignment() }}" [class.less-important]="isLessImportant()">
  @if (text()) {
    <span>{{ text() }}</span>
  } @else {
    <span>{{ 'general.aiDisclaimer' | translate }}</span>
  }
</span>
